var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23888 6.68196L6.23884 6.68192C5.94058 6.39935 5.45911 6.39935 5.16084 6.68192C4.85951 6.9674 4.85951 7.43259 5.16084 7.71807L8.96084 11.3181C9.25911 11.6006 9.74058 11.6006 10.0388 11.3181L13.8388 7.71807C14.1402 7.43259 14.1402 6.9674 13.8388 6.68192C13.5406 6.39935 13.0591 6.39935 12.7608 6.68192L9.49806 9.77298L6.23888 6.68196Z",
    fill: "#0D80FF",
    stroke: "#0D80FF",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevronDown.d7838e485d1a6ea175cfa4fff88c44d1.svg";
export { ForwardRef as ReactComponent };